import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { AsyncTools } from "@hilma/tools";
import Axios from "axios";
import { POP_UP_MESSAGE_PROBLEM, PAGE_NUMBERS } from "../consts/consts"
import { getURLOrganizationId, getURLQuestionnaireId } from "../consts/functions";
export class UsersStore {
  userInfo = {
    organizationId: "",
    firstName: "",
    lastName: "",
    city: "",
    age: "",
    gender: "",
    familyStatus: "",
    sectorId: "",
    phoneNumber: "",
    lang: "he",
  };
  questionnaireTitles = { he: "" };
  title = "";
  isKeyboardFocused = false;
  errorPopUp = false;
  errorPopUpMessage = "";
  currentPage = PAGE_NUMBERS.PHONE_NUMBER_PAGE;
  customOrganization = "";

  constructor() {
    makeObservable(this, {
      errorPopUp: observable,
      errorPopUpMessage: observable,
      userInfo: observable,
      isKeyboardFocused: observable,
      currentPage: observable,
      customOrganization: observable,
      questionnaireTitles: observable,
      title: observable,

      firstName: computed,

      updateUserInfo: action,
      showErrorPopUp: action,
      setErrorPopUpMessage: action,
      setErrorPopUp: action,
      setIsKeyboardFocused: action,
      setCurrentPage: action,
      setCustomOrganization: action,
      setTitle: action
    });
  }

  setIsKeyboardFocused(bool) {
    this.isKeyboardFocused = bool;
  }
  setErrorPopUpMessage(message) {
    this.errorPopUpMessage = message;
  }
  showErrorPopUp(message) {
    if (!this.errorPopUp) {
      this.setErrorPopUpMessage(message);
      this.setErrorPopUp(true);
      setTimeout(() => {
        this.setErrorPopUp(false);
      }, 3000);
    }
  }
  setErrorPopUp(val) {
    this.errorPopUp = val;
  }
  setCurrentPage(pageNum) {
    this.currentPage = pageNum;
  }
  setCustomOrganization(org) {
    this.customOrganization = org;
  }
  get firstName() {
    return this.userInfo.firstName;
  }

  setTitle(lang) {
    if (this.questionnaireTitles[lang]) {
      this.title = this.questionnaireTitles[lang];
    } else {
      this.title = this.questionnaireTitles[Object.keys(this.questionnaireTitles)[0]];
    }
  }

  whatPageShouldIView() {
    const {
      organizationId,
      firstName,
      lastName,
      city,
      age,
      gender,
      familyStatus,
      sector,
    } = this.userInfo;
    if (
      !organizationId ||
      !firstName ||
      !lastName ||
      !city ||
      !age ||
      !gender ||
      !familyStatus ||
      !sector
    ) {
      return "IntroductionPage";
    }
  }

  async getUserResults(updateResults) {
    const [err, res] = await AsyncTools.to(Axios.get(`/api/userAnswer/user-results/${getURLQuestionnaireId()}${updateResults ? '?updateResults=true' : ''}`));
    if (res) {
      return res;
    }
    if (err) {
      return err;
    }
  }

  async postUserInfo() {
    //check if all the info exists and if not return error
    if(!this.userInfo.phoneNumber) delete this.userInfo.phoneNumber; //if no phone, usually because its not required

    for (const info in this.userInfo) {
      if (!this.userInfo[info]) {
        return POP_UP_MESSAGE_PROBLEM;
      }
    }
    this.userInfo.questionnaireId = getURLQuestionnaireId();

    let registerPostObj = { userInfo: this.userInfo };
    if (this.customOrganization) {
      registerPostObj.customOrganization = this.customOrganization;
    }
    const [err, res] = await AsyncTools.to(Axios.post("/api/my-user/register", registerPostObj));
    if (err) {
      let errMessage;
      if (!err) {
        errMessage = "אין חיבור אינטרנט אנא נסו שנית מאוחר יותר";
        throw errMessage;
      }
      if (err.status === 500) {
        errMessage = POP_UP_MESSAGE_PROBLEM;
        throw errMessage;
      }
      return err;
    } else {
      return res;
    }
  }

  //takes an object and insert its values into userinfo (when the field is matching)
  updateUserInfo(obj) {
    for (const property in obj) {
      for (const dataField in this.userInfo) {
        if (property === dataField) {
          this.userInfo[dataField] = obj[property];
        }
      }
    }
  }

  async getQuestionnaireTitleAndCheckQuestionnaire() {
    const questionnaireId = getURLQuestionnaireId();
    const organizationId = getURLOrganizationId();
    if (questionnaireId) {
      try {
        const { data } = await Axios.get(`/api/questionnaire/questionnaire-titles-and-organization-check/${questionnaireId}/${organizationId}`);
        if (!data?.organizationConfirmed) { throw Error("NO ORGANIZATION") }
        runInAction(() => {
          this.questionnaireTitles = data?.questionnaireInfo?.title;
        });
      }
      catch (err) {
        throw err; // get out to fallback page
      }
    }
  }
}
